import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="click"
export default class extends Controller {
	static targets = ["button", "text"]
	clicks = 0
  connect() {
	  console.log("Click controller connected!!!")
  }
	addClick() {
		this.clicks ++
		console.log(`Click added, ${this.clicks} clicks so far`)
		this.textTarget.innerHTML = `Button clicked ${this.clicks} times`
	};
}
